import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Employee } from "../../models/employee/employee.model";
import { EnumOpportunityStatus } from "../../models/enum/enum-opportunity-status";
import { Opportunity } from "../../models/opportunity/opportunity.model";
import { Page } from "../../utils/page";
import {EmployeeRoleEnum} from '../../models/employee/employee-role.enum';
import {map} from 'rxjs/operators';


@Injectable({
    providedIn: 'root',
})
export class RemoteOpportunityManagerService {

    API_URL = '/apiQuoteManager/v2';


    constructor(private http: HttpClient) {
    }

    getOpportunitiesWithQuotes(employee: Employee, pageable: Map<string, string>, filters: Map<string, string>) : Observable<Page<Opportunity>> {
        const dateThreeMonthsAgo = new Date();
        dateThreeMonthsAgo.setMonth(dateThreeMonthsAgo.getMonth() - 3);
        const formattedDate = dateThreeMonthsAgo.toISOString().split('T')[0];

        let params = new HttpParams()
            .set('employeeNumber', employee.employeeNumber)
            .set('createdAfter', formattedDate);
        pageable.forEach((value, key) => params = params.set(key, value));
        filters.forEach((value, key) => params = params.set(key, value));

        return this.http.get<Page<Opportunity>>(this.API_URL + '/opportunities', { params }).pipe(
            map(response => {
                response.content = response.content.map(this.transformOpportunityRole);
                return response;
            })
        );
    }

    updateOpportunityStatus(status: string, opportunityId: number): Observable<Opportunity> {
        let body = { "status": status, "id": opportunityId };
        return this.http.post<Opportunity>(this.API_URL + '/opportunities/status', body).pipe(
            map(this.transformOpportunityRole)
        );
    }

    updateOpportunityMainQuote(mainQuoteId: string, opportunityId: number): Observable<Opportunity> {
        let body = { "mainQuoteId": mainQuoteId, "opportunityId": opportunityId };
        return this.http.post<Opportunity>(this.API_URL + '/opportunities/mainquote', body).pipe(
            map(this.transformOpportunityRole)
        );
    }

    transformOpportunityRole(opportunity: Opportunity): Opportunity {
        opportunity.roleCode = EmployeeRoleEnum.getEmployeeRoleEnumFromEforceRole(String(opportunity.roleCode));
        return opportunity;
    }

    getAvailableOpportunitiesStatus(opportunity: Opportunity) {
        const status = opportunity.status;
        switch(status) {
            case EnumOpportunityStatus.IN_PROGRESS:
                return [EnumOpportunityStatus.IN_PROGRESS, EnumOpportunityStatus.CANCELED, EnumOpportunityStatus.LOST, EnumOpportunityStatus.WON];
            case EnumOpportunityStatus.WON:
                return [EnumOpportunityStatus.WON, EnumOpportunityStatus.CANCELED, EnumOpportunityStatus.LOST, EnumOpportunityStatus.IN_PROGRESS];
            case EnumOpportunityStatus.CANCELED:
                return [EnumOpportunityStatus.CANCELED, EnumOpportunityStatus.IN_PROGRESS];
            case EnumOpportunityStatus.LOST:
                return opportunity.salesFileStatus !== null ? [EnumOpportunityStatus.LOST] : [EnumOpportunityStatus.LOST, EnumOpportunityStatus.IN_PROGRESS];
        }
    }
}
